
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UserPlus, Bot, FileText, LayoutDashboard, ChevronRight } from 'lucide-react';
import ContactDialog from './ContactDialog';
import SectionHeader from './ui/section-header';

const AIApps: React.FC = () => {
  const apps = [
    {
      icon: <UserPlus className="h-10 w-10 text-heading-accent" />,
      title: "PersonaAI Research Platform",
      description: "Behavioral AI that conducts focus groups, predicts customer responses, and generates market insights using psychological modeling",
      cta: "Explore PersonaAI →"
    },
    {
      icon: <Bot className="h-10 w-10 text-heading-accent" />,
      title: "CharX World Builder",
      description: "Create AI characters and immersive worlds with visual generation, storytelling tools, and interactive experiences",
      cta: "Try CharX →"
    },
    {
      icon: <LayoutDashboard className="h-10 w-10 text-heading-accent" />,
      title: "Business Automation Center",
      description: "Multi-business dashboard with real-time automation, webhook processing, and intelligent workflow management",
      cta: "See Demo →"
    },
    {
      icon: <FileText className="h-10 w-10 text-heading-accent" />,
      title: "DoGoodNow Social Platform",
      description: "Volunteer community platform with impact tracking, gamification, and nonprofit management tools",
      cta: "View Project →"
    }
  ];

  return (
    <section className="py-20 px-6 md:px-10 bg-white text-gray-900">
      <div className="container mx-auto">
        <SectionHeader
          badge="Featured Products"
          title="AI-Powered Apps – Ready to Use, Built to Scale"
          description="Get instant access to cutting-edge AI applications designed to automate, optimize, and enhance your business operations—without the need for custom development."
          badgeClassName="text-heading-accent"
          badgeBgClassName="bg-heading-accent/20"
          centered={true}
        />
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {apps.map((app, index) => (
            <Card 
              key={index} 
              className="p-6 border border-gray-200 shadow-md card-hover animate-fade-in-up bg-white"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="mb-5 p-3 rounded-full bg-heading-accent/10 inline-block">
                {app.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{app.title}</h3>
              <CardContent className="p-0">
                <p className="text-gray-700 mb-4">{app.description}</p>
                <div className="text-heading-accent font-medium hover:text-heading-accent/80 transition-colors">
                  {app.cta}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="mt-12 text-center animate-fade-in delay-600">
          <ContactDialog 
            trigger={
              <Button 
                size="lg" 
                className="btn-hover-effect group bg-heading-accent hover:bg-heading-accent/90 text-white"
              >
                Book Discovery Call
                <ChevronRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            }
            title="Book a Discovery Call"
            description="Fill out the form below and our team will contact you to schedule a call."
            buttonText="Submit"
            type="discovery"
          />
        </div>
      </div>
    </section>
  );
};

export default AIApps;
